import template from './switcher.html'

export default function switcherDirective() {
    return {
        restrict: 'E',
        // 指令比较重要的 scope属性实现与控制器作用域的隔离与交互，反正就是作用域不影响而又可以传参交互
        scope: {
            val: '=', // 这里接受外部的参数 并且实现与外部参数的双向数据交互
            swChange: '&',
            swDisable: '=',
        },
        template,
        // link complir 这些函数少许区别 可以看下指令api 说明
        link(scope, element) {
            const hash = (() => {
                const arr = []
                for (let i = 0; i < 10; i++) {
                    arr.push(Math.floor(Math.random() * 10))
                }
                return arr.join('')
            })()
            scope.hash_id = `switcher_${hash}` // 不重要的代码只是做随机ID

            scope.switchChange = () => {
                const val = Number(scope.onoff)
                scope.val = val
                scope.swChange({ val })
            }
            scope.$watch('val', (newValue) => {
                scope.onoff = Boolean(newValue)
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/switcher/switcherDirective.js